<template>
  <div class="filter">
    <img class="banner" src="../../assets/images/mtx-indexbg.jpg" v-if="$store.state.domainIndex==1&&bannerList.length==0">
    <img class="banner" src="../../assets/images/ml-indexbg.jpg" v-if="$store.state.domainIndex==2&&bannerList.length==0">
    <img class="banner" src="../../assets/images/indexbg_mdr.jpg" v-if="$store.state.domainIndex==3&&bannerList.length==0">
    <img class="banner" src="../../assets/images/mdr-indexbg.jpg" v-if="$store.state.domainIndex==4&&bannerList.length==0">
    <swiper :options="swiperOption" class="bannerlist" v-if="bannerList.length>0">
      <swiper-slide v-for="(item,index) in bannerList" :key="index">
        <a target="_blank" :href="item.imageUrl"><img v-lazy="item.imageSrc" /></a>
      </swiper-slide>
    </swiper>
  <!-- <div class="box"> -->
    <ul class="f-menu">
      <li class="searchbox" v-if="$store.state.domainIndex==1">
        <h1 v-if="bannerList.length==0">新房<b>找房平台</b><i>具有行业影响力的一站式优质购房服务</i></h1>
        <div class="search-type"><span class="active">找新房</span><!-- <span>公寓</span> --></div>
        <el-input placeholder="请输入楼盘名称…" v-model="searchWord">
          <el-button slot="append" icon="el-icon-search" class="search-icon" @click="search()"></el-button>
        </el-input>
      </li>
      <li class="searchbox" v-if="$store.state.domainIndex==4">
        <div class="search-type">找新房</div>
        <el-input placeholder="请输入楼盘名称…" v-model="searchWord">
          <el-button slot="append" icon="el-icon-search" class="search-icon" @click="search()"></el-button>
        </el-input>
      </li>
      <li v-if="districtItems.length!=0" @mouseenter="showPopMenu(1)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==1}">
        <i class="m-icon mi-quyu"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">区域</p>
          <router-link :key="index" v-for="(item,index) in districtItems" :to="{ name:'estate',params:{code:item.id,index:1,curr:index} }">{{item.name}}</router-link>
        </div>
      </li>
      <!-- <li v-if="subwayItems.length!=0" @mouseenter="showPopMenu(2)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==2}">
        <i class="m-icon mi-ditie"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">地铁</p>
          <router-link :key="index" v-for="(item,index) in subwayItems" v-if="index<3" :to="{ name:'estate',params:{code:item.id,index:1} }">{{item.name}}</router-link>
        </div>
      </li> -->
      <li v-if="priceItems.length!=0" @mouseenter="showPopMenu(4)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==4}">
        <i class="m-icon mi-jiage"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">价格</p>
          <router-link :key="index" v-for="(item,index) in priceItems" :to="{ name:'estate',params:{code:item.id,index:2} }">{{item.name}}</router-link>
        </div>
      </li>
      <li v-if="houseItems.length!=0&&$store.state.domainIndex!=1&&$store.state.domainIndex!=4" @mouseenter="showPopMenu(3)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==3}">
        <i class="m-icon mi-huxing"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">户型</p>
          <router-link :key="index" v-for="(item,index) in houseItems" :to="{ name:'estate',params:{code:item.id,index:3} }">{{item.name}}</router-link>
        </div>
      </li>
      <li v-if="typeItems.length!=0&&$store.state.domainIndex!=1" @mouseenter="showPopMenu(5)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==5}">
        <i class="m-icon mi-leixing"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">类型</p>
          <router-link :key="index" v-for="(item,index) in typeItems" :to="{ name:'estate',params:{code:item.id,index:4} }">{{item.name}}</router-link>
        </div>
      </li>
      <li v-if="statusItems.length!=0&&$store.state.domainIndex!=1&&$store.state.domainIndex!=4" @mouseenter="showPopMenu(6)" @mouseleave="hidePopMenu()" :class="{active: filterCurrent==6}">
        <i class="m-icon mi-zhuangtai"></i><i class="el-icon-arrow-right m-right"></i>
        <div class="m-item">
          <p class="fm-title">状态</p>
          <router-link :key="index" v-for="(item,index) in statusItems" :to="{ name:'estate',params:{code:item.id,index:5} }">{{item.name}}</router-link>
        </div>
      </li>
    </ul>
    <div class="f-menu-pop" @mouseenter="showPopMenu(1)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==1}">
      <p class="fmp-title"><router-link :to="'estate'">全部区域</router-link></p>
      <router-link :key="index" v-for="(item,index) in districtItems" :to="{ name:'estate',params:{code:item.id,index:1,curr:index} }">{{item.name}}</router-link>
    </div>
    <!-- <div class="f-menu-pop" @mouseenter="showPopMenu(2)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==2}">
      <p class="fmp-title"><router-link :to="'estate'">全部地铁</router-link></p>
      <router-link :key="index" v-for="(item,index) in subwayItems" :to="{ name:'estate',params:{code:item.id,index:1} }">{{item.name}}</router-link>
    </div> -->
    <div class="f-menu-pop" @mouseenter="showPopMenu(3)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==3}">
      <p class="fmp-title"><router-link :to="'estate'">全部户型</router-link></p>
      <router-link :key="index" v-for="(item,index) in houseItems" :to="{ name:'estate',params:{code:item.id,index:3} }">{{item.name}}</router-link>
    </div>
    <div class="f-menu-pop" @mouseenter="showPopMenu(4)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==4}">
      <p class="fmp-title"><router-link :to="'estate'">全部价格</router-link></p>
      <router-link :key="index" v-for="(item,index) in priceItems" :to="{ name:'estate',params:{code:item.id,index:2} }">{{item.name}}</router-link>
    </div>
    <div class="f-menu-pop" @mouseenter="showPopMenu(5)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==5}">
      <p class="fmp-title"><router-link :to="'estate'">全部类型</router-link></p>
      <router-link :key="index" v-for="(item,index) in typeItems" :to="{ name:'estate',params:{code:item.id,index:4} }">{{item.name}}</router-link>
    </div>
    <div class="f-menu-pop" @mouseenter="showPopMenu(6)" @mouseleave="hidePopMenu()" :class="{show: filterCurrent==6}">
      <p class="fmp-title"><router-link :to="'estate'">全部状态</router-link></p>
      <router-link :key="index" v-for="(item,index) in statusItems" :to="{ name:'estate',params:{code:item.id,index:5} }">{{item.name}}</router-link>
    </div>

    <div class="searchbox" v-if="$store.state.domainIndex==2">
      <h1 v-if="bannerList.length==0">新房找房平台<br/>一站式优质购房服务</h1>
      <el-input placeholder="请输入关键字" v-model="searchWord">
        <el-button slot="append" icon="el-icon-search" class="search-icon" @click="search()"></el-button>
      </el-input>
    </div>
  <!-- </div> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: 'PCFilter',
  components: {
    swiper,
    swiperSlide,
  },
  data () {
    return {
      districtItems:[],
      // subwayItems:[],
      houseItems:[],
      priceItems:[],
      typeItems:[],
      statusItems:[],
      filterCurrent:-1,
      isZS: false,
      searchWord:'',
      bannerList:[],
      swiperOption: {
        autoplay:{
          delay: 5000
        },
        speed: 200,
        lazy:true
      },
    }
  },
  mounted(){
    var _this = this;
    if(window.location.href.indexOf('mtxfang')!=-1 || window.location.href.indexOf('metianxia')!=-1 || window.location.href.indexOf('zmfang')!=-1 || window.location.href.indexOf('hbaichi')!=-1){
      _this.isZS = true;
    }else if(window.location.href.indexOf('qqbdc')!=-1 || window.location.href.indexOf('salehg')!=-1){
       _this.isZS = false;
    }
    _this.getFilterItem(_this.storage.get('city'));
    _this.getBanner();
  },
  created(){
    var _this = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13 && (_this.$route.path=='/estate'||_this.$route.path=='/estateSale')) {
        _this.search();
      }
    }
  },
  methods:{
    getBanner(){
      this.$http.get('/api/index/getIndexBanner?type=1').then((response)=>{
        this.bannerList = response.data.result.bannerList;
      }).catch((response)=>{
        console.log(response)
      })
    },
    search:function(){
      this.searchWord==undefined?this.searchWord='':'';
      if(this.$route.path=='/estate'||this.$route.path=='/estateSale'){
        this.$emit('getKeyword',this.searchWord);
      }else{
        this.$router.push({path:'/estate?q='+this.searchWord});
      }

    },
    getFilterItem:function(city){
      this.$http.get('/api/estateSearch/getLocationParams?locationId='+city.citySite).then((response)=>{
        this.districtItems = response.data.result.locationList
      }).catch((response)=>{
        console.log(response)
      })
      // this.$http.get('/api/estateSearch/getSubwayParams').then((response)=>{
      //   this.subwayItems = response.data.result.subwayList
      // }).catch((response)=>{
      //   console.log(response)
      // })
      this.$http.get('/api/estateSearch/getQueryParams?type=2').then((response)=>{
        this.houseItems = response.data.result.list
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getQueryParams?type=1').then((response)=>{
        this.priceItems = response.data.result.list
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getQueryParams?type=3').then((response)=>{
        this.typeItems = response.data.result.list
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getQueryParams?type=4').then((response)=>{
        this.statusItems = response.data.result.list
      }).catch((response)=>{
        console.log(response)
      })
    },
    showPopMenu:function(index){
      this.filterCurrent = index
    },
    hidePopMenu:function(){
      this.filterCurrent = -1
    }
  }
}
</script>

<style scoped>
.filter{height:400px;position:relative;}
/*.mdrbg{background-image:url(../../assets/images/indexbg_mdr.jpg)}*/
.banner{object-fit:cover;width:100%;}
.bannerlist,.banner{height:400px;position:absolute;left:0;top:0;right:0;}
.bannerlist img{display:block;width:100%;height:100%;object-fit:cover;}
.bannerlist img[lazy=error]{object-fit:contain!important;background:#f2f3f4;}
/*.filter .box{height:100%;position:relative;z-index:1;}*/
.f-menu{width:260px;height:100%;background:rgba(0,0,0,0.2);color:#eee;position:absolute;left:50%;z-index:1;margin-left:-600px;}
.f-menu li{height:20%;display:block;position:relative;line-height:25px;}
.f-menu li.active{background:rgba(0,0,0,0.2);}
.f-menu li+li:before{content:"";position:absolute;left:0;right:0;top:0;border-top:1px solid rgba(255,255,255,0.1);}
.f-menu .m-icon{position:absolute;left:15px;top:50%;margin-top:-15px;width:30px;height:30px;}
.f-menu .mi-quyu{background-position:0 -117px;}
/*.f-menu .mi-ditie{background-position:-30px -117px;}*/
.f-menu .mi-huxing{background-position:-60px -117px;}
.f-menu .mi-jiage{background-position:-90px -117px;}
.f-menu .mi-leixing{background-position:-120px -117px;}
.f-menu .mi-zhuangtai{background-position:-190px -117px;}
.f-menu .m-item{overflow:hidden;height:52px;position:absolute;top:50%;left:60px;right:30px;margin-top:-26px;}
.f-menu .fm-title{font-size:16px;padding-bottom:2px;}
.f-menu a{margin-right:8px;font-size:12px;display:inline-block;}
.f-menu a:hover{color:#fff;text-decoration: underline;}
.f-menu .m-right{position:absolute;right:10px;top:30px;font-size:20px;}
.f-menu-pop{background:rgba(0,0,0,0.2);position:absolute;left:50%;margin-left:-340px;top:0;bottom:0;width:225px;padding:15px 25px 20px 40px;/*box-shadow:2px 0 5px rgba(0,0,0,.3);*/border: 1px solid rgba(255,255,255,0.1);display:none;}
.f-menu-pop.show{display:block;z-index:2;}
.f-menu-pop a{font-size:13px;color:#eee;margin-right:15px;display:inline-block;line-height:30px;}
.f-menu-pop a:hover{color:#fff;text-decoration:underline;}
.fmp-title a{font-size:16px;line-height:40px;font-weight:bold;}

</style>



// WEBPACK FOOTER //
// src/components/public/PCFilter.vue